// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file inventory/v1/company_service.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import { CompanyInventoryService } from "./company_service_pb";

/**
 * AutocompleteCompany is a UI helper function to facilitate the creation of new companies
 * Needs to be in CompanyManagementService because it uses customer specific data to show what companies are already added
 *
 * @generated from rpc inventory.v1.CompanyInventoryService.AutocompleteCompany
 */
export const autocompleteCompany = CompanyInventoryService.method.autocompleteCompany;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.CreateCompany
 */
export const createCompany = CompanyInventoryService.method.createCompany;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.ListCompanies
 */
export const listCompanies = CompanyInventoryService.method.listCompanies;

/**
 * ListDiscoverySolutions returns solutions awaiting a connect/dismiss decision
 * (org_company_id is nil). Pending only by default; include_dismissed adds dismissed ones.
 *
 * @generated from rpc inventory.v1.CompanyInventoryService.ListDiscoverySolutions
 */
export const listDiscoverySolutions = CompanyInventoryService.method.listDiscoverySolutions;

/**
 * GetDiscoverySolution returns drawer detail for a single (unlinked) discovery solution:
 * usage (users, line-of-business, data types), and permissions.
 *
 * @generated from rpc inventory.v1.CompanyInventoryService.GetDiscoverySolution
 */
export const getDiscoverySolution = CompanyInventoryService.method.getDiscoverySolution;

/**
 * SetSolutionDismissed dismisses (dismissed=true) or restores (dismissed=false) a
 * discovery solution. Idempotent; only an unlinked solution can be dismissed.
 *
 * @generated from rpc inventory.v1.CompanyInventoryService.SetSolutionDismissed
 */
export const setSolutionDismissed = CompanyInventoryService.method.setSolutionDismissed;

/**
 * SetSolutionSuggestedThirdParty overrides the auto-suggested third-party for a discovery
 * solution with a user pick from the inventory (org_company_id set) or clears it (unset).
 *
 * @generated from rpc inventory.v1.CompanyInventoryService.SetSolutionSuggestedThirdParty
 */
export const setSolutionSuggestedThirdParty = CompanyInventoryService.method.setSolutionSuggestedThirdParty;

/**
 * AddSolutionAssignee assigns a Lema user to a discovery solution.
 *
 * @generated from rpc inventory.v1.CompanyInventoryService.AddSolutionAssignee
 */
export const addSolutionAssignee = CompanyInventoryService.method.addSolutionAssignee;

/**
 * RemoveSolutionAssignee unassigns a Lema user from a discovery solution.
 *
 * @generated from rpc inventory.v1.CompanyInventoryService.RemoveSolutionAssignee
 */
export const removeSolutionAssignee = CompanyInventoryService.method.removeSolutionAssignee;

/**
 * ListSolutionDevices returns the endpoints a discovery solution is installed on, for the drawer's
 * Devices table: the most recently used first, capped at 100. DiscoverySolution.devices_count
 * carries the true total. Empty for solutions with no endpoint source.
 *
 * @generated from rpc inventory.v1.CompanyInventoryService.ListSolutionDevices
 */
export const listSolutionDevices = CompanyInventoryService.method.listSolutionDevices;

/**
 * ListSolutionCloudAccounts returns the cloud accounts a discovery solution was found in, for the
 * drawer's Cloud Accounts table: one entry per account, ordered by classification then name, capped
 * at 500. Empty for solutions with no cloud source.
 *
 * @generated from rpc inventory.v1.CompanyInventoryService.ListSolutionCloudAccounts
 */
export const listSolutionCloudAccounts = CompanyInventoryService.method.listSolutionCloudAccounts;

/**
 * SetCloudAccountClassification overrides the classification derived from the account's
 * organizational placement and name, or clears the override when the classification is unset.
 *
 * @generated from rpc inventory.v1.CompanyInventoryService.SetCloudAccountClassification
 */
export const setCloudAccountClassification = CompanyInventoryService.method.setCloudAccountClassification;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.ListEngagements
 */
export const listEngagements = CompanyInventoryService.method.listEngagements;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.ListCompaniesDataTypes
 */
export const listCompaniesDataTypes = CompanyInventoryService.method.listCompaniesDataTypes;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.GetCompany
 */
export const getCompany = CompanyInventoryService.method.getCompany;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.GetEngagement
 */
export const getEngagement = CompanyInventoryService.method.getEngagement;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.GetCompanyDrawerMetadata
 */
export const getCompanyDrawerMetadata = CompanyInventoryService.method.getCompanyDrawerMetadata;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.UpdateCompany
 */
export const updateCompany = CompanyInventoryService.method.updateCompany;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.UpdateCompanyInherentRisk
 */
export const updateCompanyInherentRisk = CompanyInventoryService.method.updateCompanyInherentRisk;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.GetInherentRisk
 */
export const getInherentRisk = CompanyInventoryService.method.getInherentRisk;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.ListInherentRiskCategories
 */
export const listInherentRiskCategories = CompanyInventoryService.method.listInherentRiskCategories;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.SetIRQ
 */
export const setIRQ = CompanyInventoryService.method.setIRQ;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.GetCompanyActivityLog
 */
export const getCompanyActivityLog = CompanyInventoryService.method.getCompanyActivityLog;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.GetPointsOfContact
 */
export const getPointsOfContact = CompanyInventoryService.method.getPointsOfContact;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.GetPointsOfContactsByCompany
 */
export const getPointsOfContactsByCompany = CompanyInventoryService.method.getPointsOfContactsByCompany;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.GetBookmarks
 */
export const getBookmarks = CompanyInventoryService.method.getBookmarks;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.AddBookmark
 */
export const addBookmark = CompanyInventoryService.method.addBookmark;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.UpdateBookmark
 */
export const updateBookmark = CompanyInventoryService.method.updateBookmark;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.DeleteBookmark
 */
export const deleteBookmark = CompanyInventoryService.method.deleteBookmark;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.AutocompleteBusinessOwner
 */
export const autocompleteBusinessOwner = CompanyInventoryService.method.autocompleteBusinessOwner;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.CreateBusinessOwner
 */
export const createBusinessOwner = CompanyInventoryService.method.createBusinessOwner;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.UpdateBusinessOwner
 */
export const updateBusinessOwner = CompanyInventoryService.method.updateBusinessOwner;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.UpdatePointOfContact
 */
export const updatePointOfContact = CompanyInventoryService.method.updatePointOfContact;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.LinkSolutionsToCompany
 */
export const linkSolutionsToCompany = CompanyInventoryService.method.linkSolutionsToCompany;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.CreateOrgCompanyEngagement
 */
export const createOrgCompanyEngagement = CompanyInventoryService.method.createOrgCompanyEngagement;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.UpdateOrgCompanyEngagement
 */
export const updateOrgCompanyEngagement = CompanyInventoryService.method.updateOrgCompanyEngagement;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.UpdateEngagementInherentRisk
 */
export const updateEngagementInherentRisk = CompanyInventoryService.method.updateEngagementInherentRisk;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.DeleteOrgCompanyEngagement
 */
export const deleteOrgCompanyEngagement = CompanyInventoryService.method.deleteOrgCompanyEngagement;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.ReprojectOrgCompany
 */
export const reprojectOrgCompany = CompanyInventoryService.method.reprojectOrgCompany;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.ReprojectOrgCompanyEngagement
 */
export const reprojectOrgCompanyEngagement = CompanyInventoryService.method.reprojectOrgCompanyEngagement;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.UpdateOrgCompanyReAssessmentDueDate
 */
export const updateOrgCompanyReAssessmentDueDate = CompanyInventoryService.method.updateOrgCompanyReAssessmentDueDate;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.GetCompanySubprocessors
 */
export const getCompanySubprocessors = CompanyInventoryService.method.getCompanySubprocessors;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.ReanalyzeCompanySubprocessors
 */
export const reanalyzeCompanySubprocessors = CompanyInventoryService.method.reanalyzeCompanySubprocessors;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.ListAggregatedSubprocessors
 */
export const listAggregatedSubprocessors = CompanyInventoryService.method.listAggregatedSubprocessors;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.GetInherentRiskTemplate
 */
export const getInherentRiskTemplate = CompanyInventoryService.method.getInherentRiskTemplate;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.UpdateInherentRiskTemplate
 */
export const updateInherentRiskTemplate = CompanyInventoryService.method.updateInherentRiskTemplate;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.ResetInherentRiskTemplate
 */
export const resetInherentRiskTemplate = CompanyInventoryService.method.resetInherentRiskTemplate;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.DeleteOrgCompany
 */
export const deleteOrgCompany = CompanyInventoryService.method.deleteOrgCompany;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.SearchEngagementCandidates
 */
export const searchEngagementCandidates = CompanyInventoryService.method.searchEngagementCandidates;

/**
 * @generated from rpc inventory.v1.CompanyInventoryService.GetCompanyAIPosture
 */
export const getCompanyAIPosture = CompanyInventoryService.method.getCompanyAIPosture;

/**
 * Support-only. Overrides the classifier's AI profile on the GLOBAL catalog company behind this
 * inventory row, so every tenant that has the vendor sees the new verdict.
 *
 * @generated from rpc inventory.v1.CompanyInventoryService.OverrideCompanyAIProfile
 */
export const overrideCompanyAIProfile = CompanyInventoryService.method.overrideCompanyAIProfile;

/**
 * Support-only. Queues a forced classifier re-run; asynchronous, the profile changes when it completes.
 *
 * @generated from rpc inventory.v1.CompanyInventoryService.ReclassifyCompanyAIProfile
 */
export const reclassifyCompanyAIProfile = CompanyInventoryService.method.reclassifyCompanyAIProfile;
